import { useCallback } from 'react';
import { useViewerContext } from '../../../../../viewer/ViewerContext';

/**
 * @param {function} handleProgress - function called during the upload to provide a progress update
 * @param {boolean} businessId - business id
 * @param {string} source - uploading source
 * @returns {Function}
 */
export const useUploadFile = (
  handleProgress,
  businessId,
  source = 'field_value'
) => {
  const ctx = useViewerContext();
  const { onUploadFile, formId } = ctx;

  return useCallback(
    (file) => {
      return onUploadFile(file, file.$id, businessId, {
        handleProgress,
        formId,
        source,
        usePublicAPI: true,
      });
    },
    [handleProgress, businessId, onUploadFile, formId, source]
  );
};
